/* tslint:disable */
import { Equipment } from './equipment';

/**
 */
export class StudyEquipment {
    NB_MODUL?: number;
    ID_STUDY_EQUIPMENTS?: number;
    ID_EQUIP?: number;
    ID_EXH_GEN?: number;
    ID_EXH_RES?: number;
    ID_PIPE_GEN?: number;
    ID_PIPE_RES?: number;
    ID_ECONOMIC_RESULTS?: number;
    ID_STUD_EQUIPPROFILE?: number;
    ID_LAYOUT_GENERATION?: number;
    ID_LAYOUT_RESULTS?: number;
    ID_CALC_PARAMS?: number;
    LINE_ORDER?: number;
    STDEQP_LENGTH?: number;
    STDEQP_WIDTH?: number;
    EQP_INST?: number;
    AVERAGE_PRODUCT_TEMEQP_WIDTHP?: number;
    AVERAGE_PRODUCT_ENTHALPY?: number;
    ENTHALPY_VARIATION?: number;
    PRECIS?: number;
    ID_STUDY?: number;
    STACKING_WARNING?: number;
    ENABLE_CONS_PIE?: number;
    EQUIP_STATUS?: number;
    RUN_CALCULATE?: number;
    BRAIN_SAVETODB?: number;
    BRAIN_TYPE?: number;
    ID_COOLING_FAMILY?: number;
    EQUIP_NAME?: string;
    CAPABILITIES?: number;
    MODUL_LENGTH?: number;
    EQP_LENGTH?: number;
    EQP_WIDTH?: number;
    EQUIP_VERSION?: number;
    STD?: number;
    ITEM_TR?: number;
    NB_TR?: number;
    SERIES_NAME?: string;
    BATCH_PROCESS?: number;
    ORIENTATION?: number;
    equipment?: Equipment;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/study-equipment.ts